import { render, staticRenderFns } from "./UseScrapedArticleDialog.vue?vue&type=template&id=359b8c30"
import script from "./UseScrapedArticleDialog.vue?vue&type=script&lang=ts"
export * from "./UseScrapedArticleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports